module.exports = __webpack_public_path__ + "img/inventory_remaining_days.6660e6ed.svg";